// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__GJJsT","tab":"ProcedureTabs_tab__i4TT6"};